// document.addEventListener("DOMContentLoaded", async () => {

//   // --- Debounce helper function ---
//   function debounce(func, wait = 300) {
//     let timeout;
//     return function executedFunction(...args) {
//       const later = () => {
//         clearTimeout(timeout);
//         func(...args);
//       };
//       clearTimeout(timeout);
//       timeout = setTimeout(later, wait);
//     };
//   }

//   // --- Helper: get cart JSON (with caching) ---
//   let cartCache = null;
//   let lastFetchTime = 0;
//   const CACHE_DURATION = 1000; // 1 second cache

//   async function getCart(forceRefresh = false) {
//     const now = Date.now();
    
//     if (!forceRefresh && cartCache && (now - lastFetchTime) < CACHE_DURATION) {
//       console.log("🔄 Using cached cart data");
//       return cartCache;
//     }
    
//     try {
//       const res = await fetch("/cart.js");
//       const data = await res.json();
//       console.log("🛒 Fresh Cart Response:", data);
//       cartCache = data;
//       lastFetchTime = now;
//       return data;
//     } catch (err) {
//       console.error("❌ Error fetching cart:", err);
//       return cartCache || { items: [] };
//     }
//   }

//   // --- Helper: format price ---
//   function formatPrice(amountInCents) {
//     const amount = amountInCents / 100;
//     const locale = document.documentElement.lang || "en-US";
//     const currency = window.Shopify?.currency?.active || "USD";
//     return new Intl.NumberFormat(locale, { 
//       style: "currency", 
//       currency: currency, 
//       minimumFractionDigits: 2 
//     }).format(amount);
//   }

//   // --- Update mini cart ---
//   async function updateMiniCart() {
//     const miniCart = document.getElementById("header-mini-cart-content");
//     if (!miniCart) return;

//     try {
//       const res = await fetch("/cart?view=mini-cart", { cache: "no-store" });
//       miniCart.innerHTML = await res.text();

//       const priceEls = miniCart.querySelectorAll(".cart__price, .cart__total, .cart__subtotal, .cart__item-total");
//       priceEls.forEach(el => {
//         const num = parseFloat(el.textContent.replace(/[^\d.,]/g, '').replace(',', '.'));
//         if (!isNaN(num)) el.textContent = formatPrice(num * 100);
//       });
//     } catch (err) {
//       console.error("Mini cart update failed:", err);
//     }
//   }

//   // --- Get product JSON on page ---
//   function getCurrentProductData() {
//     const productDataEl = document.querySelector('[id^="ProductJson-"]');
//     if (!productDataEl) return null;
//     try {
//       const productData = JSON.parse(productDataEl.textContent);
//       console.log("📦 Current Product JSON:", productData);
//       return productData;
//     } catch (err) {
//       console.error("❌ Error parsing product JSON:", err);
//       return null;
//     }
//   }

//   // --- Add to Cart Handler ---
//   const addToCartBtn = document.querySelector(".button-add-to-cart");
//   if (addToCartBtn) {
//     addToCartBtn.addEventListener("click", async (e) => {
//       e.preventDefault();

//       const productData = getCurrentProductData();
//       if (!productData) return;

//       const variantId = productData.variants[0]?.id;
//       const currentProductType = productData.type?.trim().toLowerCase();

//       if (!variantId || !currentProductType) {
//         alert("Product variant or type missing!");
//         return;
//       }

//       // Get current cart (force fresh to avoid stale data)
//       const cart = await getCart(true);

//       // ✅ CHECK IF CART HAS MAIN PRODUCT AND GET ITS TYPE
//       let hasMain = false;
//       let mainType = null;
//       for (const item of cart.items) {
//         if (item.properties?._main_product_type) {
//           hasMain = true;
//           mainType = item.properties._main_product_type.trim().toLowerCase();
//           break; // Found main product, stop searching
//         }
//       }

//       console.log("🛒 Cart has main product:", hasMain, "mainType:", mainType);

//       // ✅ COMPATIBILITY CHECK: Accessories/attachments must match main product type
//       if (hasMain && mainType !== currentProductType) {
//         alert("⚠️ This product is not compatible with your current cart.\n\nYou can only add products of type: " + mainType);
//         return;
//       }

//       // Disable button and show spinner
//       const originalHTML = addToCartBtn.innerHTML;
//       addToCartBtn.innerHTML = '<span class="spinner"></span>';
//       addToCartBtn.disabled = true;

//       try {
//         const payload = {
//           items: [{
//             id: variantId,
//             quantity: 1,
//             properties: { _main_product_type: currentProductType }
//           }]
//         };

//         const res = await fetch("/cart/add.js", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload)
//         });

//         if (!res.ok) throw new Error("Add to cart failed");

//         const addedItem = await res.json();
//         console.log("✅ Added Item Response:", addedItem);

//         // Show added state
//         addToCartBtn.innerHTML = `
//           <span class="added-wrap" style="display:inline-flex;align-items:center;gap:8px;">
//             <span class="added-text">ADDED</span>
//             <svg class="icon-check" viewBox="0 0 24 24" fill="none">
//               <path d="M6 12.5l3.2 3.2L18 6.9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//             </svg>
//           </span>`;
//         addToCartBtn.disabled = true;

//         // Clear cache and update
//         cartCache = null;
//         await updateMiniCart();
//         debouncedHandleCheckout();
//       } catch (err) {
//         console.error("❌ Error adding product:", err);
//         alert("Error adding product to cart.");
//         addToCartBtn.innerHTML = originalHTML;
//         addToCartBtn.disabled = false;
//       }
//     });
//   }

//   // --- Checkout restriction function ---
//   async function handleCheckout() {
//     console.log('🔍 handleCheckout running');
    
//     const cart = await getCart(true);
//     const hasMain = cart.items.some(item => item.properties?._main_product_type);
//     console.log('✅ Has main product type:', hasMain);
    
//     // Find ALL checkout buttons
//     const checkoutBtns = document.querySelectorAll('[name="checkout"], .cart__checkout, button[name="checkout"], #checkout, .cart-checkout-button');
    
//     checkoutBtns.forEach(btn => {
//       btn.disabled = !hasMain;
//       btn.style.cursor = !hasMain ? "not-allowed" : "pointer";
//       btn.style.opacity = !hasMain ? "0.6" : "1";
//       btn.setAttribute('data-has-main', hasMain ? 'true' : 'false');
//     });
    
//     // Show/hide error message
//     const errorDiv = document.getElementById('checkout-error');
//     if (errorDiv) {
//       errorDiv.style.display = hasMain ? 'none' : 'block';
//     }
    
//     // Form submit handler (only add once)
//     const cartForm = document.getElementById('cart');
//     if (cartForm && !cartForm.hasAttribute('data-validation-added')) {
//       cartForm.setAttribute('data-validation-added', 'true');
      
//       cartForm.addEventListener('submit', function(event) {
//         console.log('📋 Form submit intercepted');
        
//         const hasMainAttr = document.querySelector('#checkout')?.getAttribute('data-has-main');
        
//         if (hasMainAttr !== 'true') {
//           console.log('❌ Blocking checkout - no main product');
//           event.preventDefault();
//           event.stopPropagation();
//           event.stopImmediatePropagation();
          
//           alert('⚠️ Checkout Blocked!\n\nYour cart must contain at least one Backhoe loader or Excavator.');
          
//           const errorDiv = document.getElementById('checkout-error');
//           if (errorDiv) {
//             errorDiv.style.display = 'block';
//             errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
//           }
          
//           return false;
//         }
        
//         console.log('✅ Checkout allowed - has main product');
//       });
//     }
    
//     // Button click handler (only add once)
//     const checkoutBtn = document.getElementById('checkout');
//     if (checkoutBtn && !checkoutBtn.hasAttribute('data-validation-added')) {
//       checkoutBtn.setAttribute('data-validation-added', 'true');
      
//       checkoutBtn.addEventListener('click', function(event) {
//         const hasMainAttr = this.getAttribute('data-has-main');
        
//         if (hasMainAttr !== 'true') {
//           console.log('❌ Click blocked - no main product');
//           event.preventDefault();
//           event.stopPropagation();
//           event.stopImmediatePropagation();
          
//           alert('⚠️ Checkout Blocked!\n\nYour cart must contain at least one Backhoe loader or Excavator.');
//           return false;
//         }
//       }, true); // Capture phase
//     }
//   }

//   // Create debounced version
//   const debouncedHandleCheckout = debounce(handleCheckout, 50);

//   // --- Cart page specific setup ---
//   if (window.location.pathname === '/cart' || window.location.pathname === '/cart/') {
//     console.log('🛒 Cart page - setting up validation');
    
//     // Initial run
//     handleCheckout();
    
//     // Watch for DOM changes with debounce
//     const observer = new MutationObserver(debouncedHandleCheckout);
    
//     const cartContainer = document.querySelector('.cart-footer, #main-cart-footer, .cart-blocks');
//     if (cartContainer) {
//       observer.observe(cartContainer, { 
//         childList: true, 
//         subtree: true 
//       });
//       console.log('👀 Watching cart for changes');
//     }
    
//     // Listen for cart updated events
//     document.addEventListener('cart:updated', debouncedHandleCheckout);
//   }

//   // --- Shopify cart hooks with debounce ---
//   (function () {
//     const originalFetch = window.fetch;
//     window.fetch = async function (...args) {
//       const response = await originalFetch(...args);
//       let url = '';

//       try {
//         url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
//       } catch (e) {}

//       const lowerUrl = url.toLowerCase();
//       const isCartApi =
//         lowerUrl.includes('/cart.js') ||
//         lowerUrl.includes('/cart/add') ||
//         lowerUrl.includes('/cart/update') ||
//         lowerUrl.includes('/cart/change') ||
//         lowerUrl.includes('/cart/clear');

//       if (isCartApi && (window.location.pathname === '/cart' || window.location.pathname === '/cart/')) {
//         console.log('♻️ Cart updated via fetch:', url);
//         cartCache = null; // Invalidate cache
//         debouncedHandleCheckout();
//       }

//       return response;
//     };

//     // Intercept XMLHttpRequests
//     const OriginalXHR = window.XMLHttpRequest;
//     window.XMLHttpRequest = function () {
//       const xhr = new OriginalXHR();
//       let _url = '';

//       const open = xhr.open;
//       xhr.open = function (method, url) {
//         _url = url;
//         return open.apply(this, arguments);
//       };

//       xhr.addEventListener('loadend', function () {
//         if (_url.includes('/cart') && (window.location.pathname === '/cart' || window.location.pathname === '/cart/')) {
//           console.log('🧾 XHR cart request detected:', _url);
//           cartCache = null; // Invalidate cache
//           debouncedHandleCheckout();
//         }
//       });

//       return xhr;
//     };

//     console.log('✅ Shopify cart hook ready');
//   })();

//   // --- Mini cart click handler ---
//   const miniCart = document.getElementById('HeaderMiniCart');
//   if (miniCart) {
//     miniCart.addEventListener('click', () => {
//       console.log('Mini cart clicked → running handleCheckout()');
//       debouncedHandleCheckout();
//     });
//   }

// });


      //  Added the language trasnlator obj 
let languageTrasnnslations={
fi:{
"Minikaivuri":"Excavator" ,
"Dumpperi":"Dumper",
"Skid steer":"Skid steer",
"Mini skid steer":"Skid steer",
"Traktori":"Tractor",
"Kuormaaja":"Loader",
"Kaivurikuormaaja":"Backhoe loader"
}
};


// Added the ReTrasnlator Obj  For Showing Messages to client

let CollectionConverterOBJ={
  fi:{
    "Excavator":"Minikaivuri",
    "Dumper":"Dumpperi",
    "Skid steer":"Mini skid steer",
    "Tractor":"Traktori",
    "Loader":"Kuormaaja",
    "Backhoe loader":"Kaivurikuormaaja",
    "Wood machine":"Puuntyöstökone"
  }
}

// added the Error Message Translator Object

let ErrorMessageTraslator={
  en:{
    existingAttachmentMSG:'You already have attachments for "{existingType}" in cart. Remove them before adding attachments for "{collectionName}".',
    maxAttachmentLimit:"Maximum {limit} compatible attachments allowed for {collectionName} products.",
    notCompatableMSG:"Your attachment is not Compatable with Your Cart Please first Remove the product from the cart",
    existingAccessroiesMSG:'You already have (accessories) for "{existingType}" in cart. Remove them before adding (accessories) for "{collectionName}".',
    addtoCartErrorMSG:"Error adding product to cart.",
    updatecartErrorMSG:"⚠️ Maximum '{limit}'  compatible attachments allowed for: '{collectionType}' products.\n\nQuantity adjusted to: '{correctedQty}'\n\nAttachments:\n '{itemNames}'",
    mainproductQtyMSG:"⚠️ You can only have quantity 1 for the main product."
  },
  fi:{
    existingAttachmentMSG:'Sinulla on jo liitteitä tyypille "{existingType}" ostoskorissa. Poista ne ennen kuin lisäät liitteitä kokoelmalle "{collectionName}".',
    maxAttachmentLimit:"Enintään {limit} yhteensopivaa lisälaitetta sallittu {collectionName} -tuotteille.",
    notCompatableMSG:"Liitteesi ei ole yhteensopiva ostoskorisi kanssa. Poista ensin tuote ostoskorista.",
    existingAccessroiesMSG:'Sinulla on jo (tarvikkeita) tyypille "{existingType}" ostoskorissa. Poista ne ennen kuin lisäät (tarvikkeita) kokoelmalle "{collectionName}".',
     addtoCartErrorMSG:"Virhe tuotteen lisäämisessä ostoskoriin.",
      updatecartErrorMSG:"⚠️ Enintään {limit} yhteensopivaa lisälaitetta sallittu tuotteille: {collectionType}.\n\nMäärä mukautettu arvoon: {correctedQty}\n\nLiitteet:\n {itemNames}",
          mainproductQtyMSG:"⚠️ Voit pitää päätuotteelle vain määrän 1."



  }
}

let currentwindowlanguage =window.currentLanguage || "en"
console.log("CurrentLangusge....",currentwindowlanguage);









document.addEventListener("DOMContentLoaded", async () => {

  function debounce(func, wait = 300) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  let cartCache = null;
  let lastFetchTime = 0;
  const CACHE_DURATION = 1000;

  async function getCart(forceRefresh = false) {
    const now = Date.now();
    
    if (!forceRefresh && cartCache && (now - lastFetchTime) < CACHE_DURATION) {
      return cartCache;
    }
    
    try {
      const res = await fetch("/cart.js");
      const data = await res.json();
      cartCache = data;
      lastFetchTime = now;
      return data;
    } catch (err) {
      console.error("❌ Error fetching cart:", err);
      return cartCache || { items: [] };
    }
  }

  function formatPrice(amountInCents) {
    const amount = amountInCents / 100;
    const locale = document.documentElement.lang || "en-US";
    const currency = window.Shopify?.currency?.active || "USD";
    return new Intl.NumberFormat(locale, { 
      style: "currency", 
      currency: currency, 
      minimumFractionDigits: 2 
    }).format(amount);
  }

  async function updateMiniCart() {
    const miniCart = document.getElementById("header-mini-cart-content");
    if (!miniCart) return;

    try {
      const res = await fetch("/cart?view=mini-cart", { cache: "no-store" });
      miniCart.innerHTML = await res.text();

      const priceEls = miniCart.querySelectorAll(".cart__price, .cart__total, .cart__subtotal, .cart__item-total");
      priceEls.forEach(el => {
        const num = parseFloat(el.textContent.replace(/[^\d.,]/g, '').replace(',', '.'));
        if (!isNaN(num)) el.textContent = formatPrice(num * 100);
      });
    } catch (err) {
      console.error("Mini cart update failed:", err);
    }
  }

  function getCurrentProductData() {
    const productDataEl = document.querySelector('[id^="ProductJson-"]');
    console.log("productElement...",productDataEl);
    
    if (!productDataEl) return null;
    try {
      const productData = JSON.parse(productDataEl.textContent);
      return productData;
    } catch (err) {
      console.error("❌ Error parsing product JSON:", err);
      return null;
    }
  }

  const ATTACHMENT_TYPES = ['attachment', 'attachments',"Attachment"];
  const ACCESSORY_TYPES = ['accessory', 'accessories'];

  function getProductCategory(productType) {
    const type = productType?.trim().toLowerCase();
    if (!type) return 'unknown';
    
    if (ATTACHMENT_TYPES.includes(type)) return 'attachment';
    if (ACCESSORY_TYPES.includes(type)) return 'accessory';
    return 'main';
  }

  async function validateQuantityChange(lineIndex, newQty) {
    const cart = await getCart(true);
    
    const item = cart.items[lineIndex - 1];
    
    if (!item) return true;
    
    if (!item.properties || !item.properties._compatible_attachment) {
      return true;
    }
    
    const collectionType = item.properties._compatible_attachment;
    
    let settings = { Excavator: 5, Loader: 4, Other: 100 };
    try {
      const res = await fetch('https://calculator-app-7keui.ondigitalocean.app/api/attachments/settings');
      const data = await res.json();
      if (data.success && data.settings) {
        settings = data.settings;
      }
    } catch (err) {
      console.warn('Using default limits');
    }
    
    const key = Object.keys(settings).find(k => 
      k.toLowerCase() === collectionType.toLowerCase()
    );
    const limit = key ? settings[key] : 9999;
    
    const attachments = cart.items.filter(i => 
      i.properties && i.properties._compatible_attachment === collectionType
    );
    
    let newTotal = 0;
    attachments.forEach(i => {
      if (i.variant_id === item.variant_id) {
        newTotal += newQty;
      } else {
        newTotal += i.quantity;
      }
    });
    
    console.log(`📊 ${collectionType} | New total would be: ${newTotal} | Limit: ${limit}`);
    
    if (newTotal > limit) {
      const itemNames = attachments.map(i => `${i.product_title} (qty: ${i.quantity})`).join('\n');
      alert(`⚠️ Maximum ${limit} compatible attachments allowed for. ${collectionType} products.\n\nCurrent total: ${newTotal - newQty + item.quantity}\n\nAttachments:\n${itemNames}`);
      return false;
    }
    
    return true;
  }

  // (function () {
  //   const originalFetch = window.fetch;
    
  //   window.fetch = async function (...args) {
  //     let url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      
  //     if (url.includes('/cart/change') || url.includes('/cart/update')) {
  //       console.log('🛑 Intercepting cart update:', url);
        
  //       let requestData = null;
        
  //       if (args[1] && args[1].body) {
  //         try {
  //           if (typeof args[1].body === 'string') {
  //             requestData = JSON.parse(args[1].body);
  //           } else if (args[1].body instanceof FormData) {
  //             requestData = {};
  //             for (let [key, value] of args[1].body.entries()) {
  //               requestData[key] = value;
  //             }
  //           } else if (args[1].body instanceof URLSearchParams) {
  //             requestData = Object.fromEntries(args[1].body);
  //           }
  //         } catch (e) {
  //           console.log('Could not parse request body');
  //         }
  //       }
        
  //       console.log('📦 Request data:', requestData);
        
  //       if (requestData) {
  //         let lineIndex = null;
  //         let newQty = null;
          
  //         if (requestData.id && requestData.quantity !== undefined) {
  //           lineIndex = parseInt(requestData.id);
  //           newQty = parseInt(requestData.quantity);
  //         } else if (requestData.line && requestData.quantity !== undefined) {
  //           lineIndex = parseInt(requestData.line);
  //           newQty = parseInt(requestData.quantity);
  //         } else if (requestData.updates) {
  //           const updates = requestData.updates;
  //           for (let key in updates) {
  //             lineIndex = parseInt(key);
  //             newQty = parseInt(updates[key]);
  //             break;
  //           }
  //         }
          
  //         console.log(`🔍 Validating: Line ${lineIndex}, New Qty ${newQty}`);
          
  //         if (lineIndex && newQty !== null) {
  //           const isValid = await validateQuantityChange(lineIndex, newQty);
            
  //           if (!isValid) {
  //             console.log('❌ BLOCKED - Returning current cart state');
              
  //             const currentCart = await getCart(true);
              
  //             return new Response(JSON.stringify(currentCart), {
  //               status: 200,
  //               headers: { 'Content-Type': 'application/json' }
  //             });
  //           }
  //         }
  //       }
  //     }
      
  //     const response = await originalFetch(...args);
      
  //     const isCartApi = 
  //       url.includes('/cart.js') || 
  //       url.includes('/cart/add') || 
  //       url.includes('/cart/clear');
      
  //     if (isCartApi && !url.includes('/cart/change') && !url.includes('/cart/update')) {
  //       cartCache = null;
  //       setTimeout(() => {
  //         debouncedHandleCheckout();
  //       }, 300);
  //     }
      
  //     return response;
  //   };
  // })();

(function () {
  const originalFetch = window.fetch;
  
  window.fetch = async function (...args) {
    let url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    // console.log("running..");
    
    if (url.includes('/cart/change') || url.includes('/cart/update')) {
      console.log('🛑 Intercepting cart update:', url);
      
      let requestData = null;
      
      if (args[1] && args[1].body) {
        try {
          if (typeof args[1].body === 'string') {
            requestData = JSON.parse(args[1].body);
          } else if (args[1].body instanceof FormData) {
            requestData = {};
            for (let [key, value] of args[1].body.entries()) {
              requestData[key] = value;
            }
          } else if (args[1].body instanceof URLSearchParams) {
            requestData = Object.fromEntries(args[1].body);
          }
        } catch (e) {
          console.log('Could not parse request body');
        }
      }
      
      if (requestData) {
        let lineIndex = null;
        let newQty = null;
        
        if (requestData.id && requestData.quantity !== undefined) {
          lineIndex = parseInt(requestData.id);
          newQty = parseInt(requestData.quantity);
        } else if (requestData.line && requestData.quantity !== undefined) {
          lineIndex = parseInt(requestData.line);
          newQty = parseInt(requestData.quantity);
        } else if (requestData.updates) {
          const updates = requestData.updates;
          for (let key in updates) {
            lineIndex = parseInt(key);
            newQty = parseInt(updates[key]);
            break;
          }
        }
        
        console.log(`🔍 Checking: Line ${lineIndex}, Requested Qty ${newQty}`);
        
        if (lineIndex && newQty !== null) {
          // ✅ VALIDATE BEFORE allowing the change
          const cart = await getCart(true);
          const item = cart.items[lineIndex - 1];
          

          console.log("item...",item);


          if (item && item.properties && item.properties._compatible_attachment) {
            const collectionType = item.properties._compatible_attachment;
          console.log("collectionType..",collectionType);

            let settings ={
        "Excavator": 5,
        "Dumper": 6,
        "Skid steer": 6,
        "Tractor": 4,
        "Loader": 4,
        "Backhoe loader": 2
    }

            console.log("settings....",settings);
            
            try {
              const res = await originalFetch('https://calculator-app-7keui.ondigitalocean.app/api/attachments/settings');
              const data = await res.json();
              if (data.success && data.settings) {
                settings = data.settings;
              }
            } catch (err) {
              console.warn('Using default limits');
            }
            
            const key = Object.keys(settings).find(k => 
              k.toLowerCase() === collectionType.toLowerCase()
            );
            const limit = key ? settings[key] : 5;
            
            const attachments = cart.items.filter(i => 
              i.properties && i.properties._compatible_attachment === collectionType
            );
            
            // Calculate what the new total WOULD be
            let newTotal = 0;
            attachments.forEach(i => {
              if (i.variant_id === item.variant_id) {
                newTotal += newQty; // Use the new quantity for this item
              } else {
                newTotal += i.quantity;
              }
            });
            
            console.log(`📊 ${collectionType} | New total would be: ${newTotal} | Limit: ${limit}`);
            
            if (newTotal > limit) {
              // ✅ Calculate the corrected quantity
              const excess = newTotal - limit;
              const correctedQty = Math.max(0, newQty - excess);
              
              console.log(`🔧 Correcting from ${newQty} to ${correctedQty}`);
              
              // ✅ Show alert (this blocks until user clicks OK)
              const itemNames = attachments.map(i => `${i.product_title} (qty: ${i.quantity})`).join('\n');
              let convertedCollectiontype=CollectionConverterOBJ[currentwindowlanguage]?.[collectionType]  || collectionType;
              console.log("convertedcollection..",convertedCollectiontype);
              console.log("iteamsName::",itemNames);
              
              
              let updatecarterrormsg=ErrorMessageTraslator[currentwindowlanguage]?.updatecartErrorMSG?.replace("{limit}",String(limit))?.replace("{collectionType}",convertedCollectiontype)?.replace("{correctedQty}",String(correctedQty))?.replace("{itemNames}",itemNames);
              console.log("updatecarterrormsg::",updatecarterrormsg);
              
             alert( updatecarterrormsg ||    `⚠️ Maximum ${limit} compatible attachments allowed for: ${collectionType} products.\n\nQuantity adjusted to: ${correctedQty}\n\nAttachments:\n${itemNames}`);

              // alert(`⚠️ Maximum ${limit} compatible attachments allowed for: ${collectionType} products.\n\nQuantity adjusted to: ${correctedQty}\n\nAttachments:\n${itemNames}`);
              
              // ✅ CHANGE the request to use corrected quantity
              if (requestData.id) {
                requestData.quantity = correctedQty;
              } else if (requestData.line) {
                requestData.quantity = correctedQty;
              } else if (requestData.updates) {
                requestData.updates[lineIndex] = correctedQty;
              }
              
              // ✅ Update the request body with corrected data
              if (args[1].body instanceof URLSearchParams) {
                args[1].body.set('quantity', correctedQty);
              } else if (typeof args[1].body === 'string') {
                args[1].body = JSON.stringify(requestData);
              }
              
              console.log('📦 Modified request to:', correctedQty);
            }
          }else if (item && item.properties && item.properties._main_product_type) {
            // ✅ main product line → force quantity 1

  if (newQty > 1) {
    let qntyMSG=ErrorMessageTraslator[currentwindowlanguage]?.mainproductQtyMSG;
    alert(qntyMSG || "⚠️ You can only have quantity 1 for the main product.");
    newQty = 1;

    // update the parsed requestData
    if (requestData.id || requestData.line) {
      requestData.quantity = 1;
    } else if (requestData.updates) {
      requestData.updates[lineIndex] = 1;
    }

    // update the actual request body
    if (args[1].body instanceof URLSearchParams) {
      args[1].body.set("quantity", "1");
    } else if (typeof args[1].body === "string") {
      args[1].body = JSON.stringify(requestData);
    }

    console.log("📦 Main product quantity forced to 1");
  }
}
        }
      }
    }
    
    const response = await originalFetch(...args);
    
    const isCartApi = 
      url.includes('/cart.js') || 
      url.includes('/cart/add') || 
      url.includes('/cart/clear');
    
    if (isCartApi && !url.includes('/cart/change') && !url.includes('/cart/update')) {
      cartCache = null;
      setTimeout(() => {
        debouncedHandleCheckout();
      }, 300);
    }
    
    return response;
  };
})();

// ---- Added the Add to cart Fucntily for the Acccessroies and Attachments ----
function initCompatiblePopup() { 
  console.log("initCompatiblePopup running");
  console.log("currentwindowlanguage....",currentwindowlanguage);
  const SETTINGS_URL = "https://calculator-app-7keui.ondigitalocean.app/api/attachments/settings";
  const DEFAULT_SETTINGS = {
        "Excavator": 5,
        "Dumper": 6,
        "Skid steer": 6,
        "Tractor": 4,
        "Loader": 4,
        "Backhoe loader": 2
    }






  async function fetchJSON(url, opts = {}, timeoutMs = 8000) {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), timeoutMs);
    try {
      const res = await fetch(url, { ...opts, signal: ctrl.signal });
      if (!res.ok) throw new Error("HTTP " + res.status);
      return await res.json();
    } finally {
      clearTimeout(t);
    }
  }

  async function getSettings() {
    try {
      const data = await fetchJSON(SETTINGS_URL, { headers: { Accept: "application/json" } }, 12000);
      window.LimitOBJ= data && data.success && data.settings ? data.settings : DEFAULT_SETTINGS;
      console.log("LimitOBJ..",LimitOBJ)
    } catch (err) {
      console.warn("[compatible] settings fallback", err);
      window.LimitOBJ=  DEFAULT_SETTINGS;
    }
  }
     getSettings().then((s) => {
    
    console.log("settings loaded once",window.LimitOBJ );
  });




  async function getCart() {
    try {
      return await fetchJSON("/cart.js", { headers: { Accept: "application/json" } }, 8000);
    } catch (err) {
      console.warn("[compatible] cart fallback", err);
      return { items: [] };
    }
  }

  async function updateMiniCart() {
    const miniCart = document.getElementById("header-mini-cart-content");
    if (!miniCart) return;
    try {
      const res = await fetch("/cart?view=mini-cart", { cache: "no-store" });
      miniCart.innerHTML = await res.text();
    } catch (e) {
      console.error("[compatible] mini-cart update failed", e);
    }
  }

  // ONE global listener for all forms in loop
//   document.addEventListener("click", async (e) => {
//     // target: button inside <form class="ajax-add-to-cart">
//     const btn = e.target.closest("form.ajax-add-to-cart button.btn.btn-red[type='submit']");
//     if (!btn) return;

//     e.preventDefault(); // stop normal submit
//     console.log("compatible popup button clicked", btn);

//     const form = btn.closest("form.ajax-add-to-cart");
//     const card = form.closest(".compat-card");
//     const popupRoot = card.closest(".compatible-popup");

//     const originalHTML = btn.innerHTML;
//     const addedLabel = btn.getAttribute("data-added-label") || "ADDED";

//     // show spinner on this button
//     btn.innerHTML = '<span class="spinner"></span>';
//     btn.disabled = true;

//     // disable all popup add buttons
//     document
//       .querySelectorAll("form.ajax-add-to-cart button.btn.btn-red[type='submit']")
//       .forEach((b) => (b.disabled = true));

//     const restore = () => {
//       document
//         .querySelectorAll("form.ajax-add-to-cart button.btn.btn-red[type='submit']")
//         .forEach((b) => (b.disabled = false));
//       btn.innerHTML = originalHTML;
//       btn.disabled = false;
//     };

//     try {
//       // 1) get variant id
//       const variantId = form.querySelector("input[name='id']")?.value;
//       let currentProductType = document.querySelector("[data-product-type]")?.getAttribute("data-product-type") || "";
//       let producttypeWithoutChnaged=currentProductType;
//       console.log("productType..",currentProductType);

//       // convert the language based the seleted language

//         currentProductType= languageTrasnnslations[currentwindowlanguage]?.[currentProductType] || currentProductType;




//       if (!variantId) {
//         console.error("[compatible] No variant id found");
//         restore();
//         return;
//       }
//       console.log("variantId...",variantId);
      

//       // 2) check if this is an attachment (hidden field exists)
//       const attachmentInput = form.querySelector(
//         '[name="properties[_compatible_attachment]"]'
//       );

      
//       const isAttachment = !!attachmentInput;
//       console.log("attachmentInput..",isAttachment);

//       let collectionName = currentProductType;
//       // get the cart iteams
//         const cart = await getCart();

//       if (isAttachment) {
//         // 2a) get collection name from data-collection on card
//         // const rawCollections = (card.dataset.collection || "").trim();
//         // console.log("rawCollections..",rawCollections);
        
//         // const productCollections = rawCollections
//         //   ? rawCollections.split(",").map((s) => s.trim()).filter(Boolean)
//         //   : [];

//         // 2b) load limits
//         // const settings = await getSettings();
//          const settings = window.LimitOBJ
//         console.log("settings..",settings);
        
//         // const match = productCollections.find((c) =>
//         //   Object.keys(settings).some((k) => k.toLowerCase() === c.toLowerCase())
//         // );
//         // collectionName = match || "Other";
//         const key = Object.keys(settings).find(
//           (k) => k.toLowerCase() === collectionName.toLowerCase()
//         );
//         console.log("key..",key);
        
//         const limit = key ? Number(settings[key]) : 5;
//           console.log("limit..",limit); 

//         // 2c) read cart for validation
//         // const cart = await getCart();
//         const existingAttachments = (cart.items || []).filter(
//           (i) => i?.product_type=="Attachment"
//         );

//         console.log("existingAttachments..",existingAttachments);
        

//         // conflict: different type already in cart
//         const conflicting = existingAttachments.find(
//           (i) =>
//             (i.properties?._collectionname || "").toLowerCase() !==
//             collectionName.toLowerCase()
//         );

//         console.log("conflicting..",conflicting);
        
//         if (conflicting) {
//           // console.log("collectionname::",CollectionConverterOBJ[currentwindowlanguage]?.existingType);
          
//           const existingType = conflicting.properties._collectionname;
//           const tpl =
//            ErrorMessageTraslator[currentwindowlanguage]?.existingAttachmentMSG ||
//             'You already have attachments for "{existingType}" in cart. Remove them before adding attachments for "{collectionName}".';
//           const msg = tpl
//             .replace("{existingType}",CollectionConverterOBJ[currentwindowlanguage]?.[existingType] || existingType)
//             .replace("{collectionName}", producttypeWithoutChnaged);
//           alert(`⚠️ ${msg}`);
//           restore();
//           return;
//         }

//         // limit for same type
//         const countSameType = existingAttachments.filter(
//           (i) =>
//             (i.properties._collectionname || "").toLowerCase() ===
//             collectionName.toLowerCase()
//         );
//         console.log("count..",countSameType);

//         let totalQuantity=0;
//         countSameType?.forEach((m)=>{
//           totalQuantity+=m?.quantity ||1;
//         })

//         console.log("quantity..",totalQuantity);
        
        

//         if (totalQuantity >= limit) {
//           const tpl =
//             ErrorMessageTraslator[currentwindowlanguage]?.maxAttachmentLimit ||
//             "Maximum {limit} compatible attachments allowed for {collectionName} products.";
//           const msg = tpl
//             .replace("{limit}", String(limit))
//             .replace("{collectionName}", producttypeWithoutChnaged);
//           alert(`⚠️ ${msg}`);
//           restore();
//           return;
//         }

//         // now lets find the main product in the cart
//        const existingMainproduct = (cart.items || []).filter(
//           (i) => i?.properties?._main_product_type
//         );
//         console.log("existingMainproduct..",existingMainproduct);


//         if(existingMainproduct?.length>0){
//        let MainProductmismatch= existingMainproduct.find((m)=>  m?.properties?._main_product_type && m.properties._main_product_type.toLowerCase() !== collectionName.toLowerCase());
//       console.log("MainProductmismatch..",MainProductmismatch);
 
//      if(MainProductmismatch){

//  const tpl =ErrorMessageTraslator[currentwindowlanguage]?.notCompatableMSG ||  "Your attachment is not Compatable with Your Cart Please first Remove the product from the cart";
//           const msg = tpl
           
//           alert(`⚠️ ${msg}`);
//           restore();
//           return;

// }
//         }




//       }else{
//      // ---------- ACCESSORIES ----------
//       // same rule but check product_type === "Accessory"
//       const existingAccessories = (cart.items || []).filter(
//         (i) => i?.product_type === "accessory"
//       );
//       console.log("existingAccessories (accessories)..", existingAccessories);

//       // conflict: different collection already in cart (for accessories)
//       const conflictingAcc = existingAccessories.find(
//         (i) =>
//           (i.properties?._collectionname || "").toLowerCase() !==
//           collectionName.toLowerCase()
//       );
//       console.log("conflictingAcc..", conflictingAcc);

//       if (conflictingAcc) {
//         const existingType = conflictingAcc.properties._collectionname;
//         const tpl =
//           ErrorMessageTraslator[currentwindowlanguage]?.existingAccessroiesMSG ||
//           'You already have (accessories) for "{existingType}" in cart. Remove them before adding (accessories) for "{collectionName}".';
//         const msg = tpl
//           .replace("{existingType}",CollectionConverterOBJ[currentwindowlanguage]?.[existingType] || existingType)
//           .replace("{collectionName}", producttypeWithoutChnaged);
//         alert(`⚠️ ${msg}`);
//         restore();
//         return;
//       }





//       }


      

//       // 3) build payload and add to cart
//       const fd = new FormData();
//       fd.set("id", variantId);
//       if (isAttachment && collectionName) {
//         fd.set("properties[_compatible_attachment]", collectionName);
//       }
//       if(collectionName){
//                 fd.set("properties[_collectionname]", collectionName);
//         // fd.set("properties[_compatible_attachment]", collectionName);

//       }

//       const res = await fetch("/cart/add.js", {
//         method: "POST",
//         headers: { Accept: "application/json" },
//         body: fd,
//       });
//       // if (!res.ok) throw await res.json();
//       if (!res.ok) {
//   const errorData = await res.json();      // parse error response
//   console.log("Add to cart error:", errorData);
//   throw errorData;                         // or throw new Error(...)
// }

//       // 4) show ADDED state, update mini cart
//       btn.innerHTML = `
//         <span class="added-wrap" style="display:inline-flex;align-items:center;gap:8px;">
//           <span class="added-text">${addedLabel}</span>
//           <svg class="icon-check" viewBox="0 0 24 24" fill="none">
//             <path d="M6 12.5l3.2 3.2L18 6.9"
//                   stroke="currentColor" stroke-width="2"
//                   stroke-linecap="round" stroke-linejoin="round"/>
//           </svg>
//         </span>`;
//       btn.classList.add("is-added");

//       document
//         .querySelectorAll("form.ajax-add-to-cart button.btn.btn-red[type='submit']")
//         .forEach((b) => (b.disabled = false));

//       await updateMiniCart();

//       setTimeout(() => {
//         btn.innerHTML = originalHTML;
//         btn.classList.remove("is-added");
//       }, 1500);
//     } catch (err) {
//       console.error("[compatible] Error adding popup product:", err);
//       const errorMsg =
//          ErrorMessageTraslator[currentwindowlanguage]?.addtoCartErrorMSG ||
//          "Error adding product to cart.";
//       alert(errorMsg);
//       restore();
//     }
//   });
}

// run immediately if DOM is ready, otherwise wait for DOMContentLoaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCompatiblePopup);
} else {
  initCompatiblePopup();
}






  // const addToCartBtn = document.querySelector(".button-add-to-cart");
  // if (addToCartBtn) {
  //   console.log("Starting..");
  //   addToCartBtn.addEventListener("click", async (e) => {
  //         console.log("Starting2..");

  //     e.preventDefault();
  //     const productData = getCurrentProductData();
  //     console.log("productResponse...",productData);
      
  //     if (!productData) return;

  //     const variantId = productData.variants[0]?.id;
  //     const currentProductType = productData.type?.trim().toLowerCase();
  //     console.log("currentProductType...",productData.type?.trim());  
  //     if (!variantId || !currentProductType) {
  //       alert("Product variant or type missing!");
  //       return;
  //     }

  //     const cart = await getCart(true);

  //     let mainProductType = null;
      
  //     for (const item of cart.items) {
  //       if (item.properties?._main_product_type) {
  //         mainProductType = item.properties._main_product_type.trim().toLowerCase();
  //         break;
  //       }
  //     }

  //     const currentCategory = getProductCategory(currentProductType);

  //     if (mainProductType) {
  //       if (currentCategory === 'main') {
  //         if (currentProductType !== mainProductType) {
  //           alert(`⚠️ Cannot Mix Main Products!\n\nYour cart contains "${mainProductType}" products.\n\nPlease empty your cart before adding "${currentProductType}".`);
  //           return;
  //         }
  //       } else if (currentCategory === 'attachment' || currentCategory === 'accessory') {
  //         console.log(`✅ Adding ${currentCategory} for ${mainProductType}`);
  //       } else {
  //         alert("⚠️ This product type is not recognized. Please contact support.");
  //         return;
  //       }
  //     } else {
  //       if (currentCategory === 'attachment' || currentCategory === 'accessory') {
  //         alert(`⚠️ Cannot Add ${currentCategory.charAt(0).toUpperCase() + currentCategory.slice(1)}!\n\nYou must add a main product (equipment) first before adding attachments or accessories.`);
  //         return;
  //       }
  //       mainProductType = currentProductType;
  //     }

  //     const originalHTML = addToCartBtn.innerHTML;
  //     addToCartBtn.innerHTML = '<span class="spinner"></span>';
  //     addToCartBtn.disabled = true;

  //     try {
  //       const payload = {
  //         items: [{
  //           id: variantId,
  //           quantity: 1,
  //           properties: { _main_product_type: mainProductType }
  //         }]
  //       };

  //       const res = await fetch("/cart/add.js", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(payload)
  //       });

  //       if (!res.ok) throw new Error("Add to cart failed");

  //       const addedItem = await res.json();

  //       addToCartBtn.innerHTML = `
  //         <span class="added-wrap" style="display:inline-flex;align-items:center;gap:8px;">
  //           <span class="added-text">ADDED</span>
  //           <svg class="icon-check" viewBox="0 0 24 24" fill="none">
  //             <path d="M6 12.5l3.2 3.2L18 6.9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  //           </svg>
  //         </span>`;
  //       addToCartBtn.disabled = true;

  //       cartCache = null;
  //       await updateMiniCart();
  //       debouncedHandleCheckout();
  //     } catch (err) {
  //       console.error("❌ Error adding product:", err);
  //       alert("Error adding product to cart.");
  //       addToCartBtn.innerHTML = originalHTML;
  //       addToCartBtn.disabled = false;
  //     }
  //   });
  // }

  async function handleCheckout() {
    // console.log("checkout btn clicked..");
    
    const cart = await getCart();
    const hasMain = cart.items.some(item => item.properties?._main_product_type);
    
    const checkoutBtns = document.querySelectorAll('[name="checkout"], .cart__checkout, button[name="checkout"], #checkout, .cart-checkout-button');
    
    checkoutBtns.forEach(btn => {
      btn.disabled = !hasMain;
      btn.style.cursor = !hasMain ? "not-allowed" : "pointer";
      btn.style.opacity = !hasMain ? "0.6" : "1";
      btn.setAttribute('data-has-main', hasMain ? 'true' : 'false');
    });
    
    const errorDiv = document.getElementById('checkout-error');
    if (errorDiv) {
      errorDiv.style.display = hasMain ? 'none' : 'block';
    }
    
    const cartForm = document.getElementById('cart');
    if (cartForm && !cartForm.hasAttribute('data-validation-added')) {
      cartForm.setAttribute('data-validation-added', 'true');
      
      cartForm.addEventListener('submit', function(event) {
        const hasMainAttr = document.querySelector('#checkout')?.getAttribute('data-has-main');
        
        if (hasMainAttr !== 'true') {
          event.preventDefault();
          event.stopPropagation();
          alert('⚠️ Checkout Blocked! Cart must contain at least one main product.');
          return false;
        }
      });
    }
    
    const checkoutBtn = document.getElementById('checkout');
    if (checkoutBtn && !checkoutBtn.hasAttribute('data-validation-added')) {
      checkoutBtn.setAttribute('data-validation-added', 'true');
      
      checkoutBtn.addEventListener('click', function(event) {
        const hasMainAttr = this.getAttribute('data-has-main');
        
        if (hasMainAttr !== 'true') {
          event.preventDefault();
          event.stopPropagation();
          alert('⚠️ Checkout Blocked! Cart must contain at least one main product.');
          return false;
        }
      }, true);
    }
  }

  const debouncedHandleCheckout = debounce(handleCheckout, 300);

  if (window.location.pathname === '/cart' || window.location.pathname === '/cart/') {
    handleCheckout();
    
    const observer = new MutationObserver(debouncedHandleCheckout);
    const cartContainer = document.querySelector('.cart-footer, #main-cart-footer, .cart-items, #main-cart-items');
    if (cartContainer) {
      observer.observe(cartContainer, { childList: true, subtree: true });
    }
  }

  const miniCart = document.getElementById('HeaderMiniCart');
  if (miniCart) {
    miniCart.addEventListener('click', () => {
      setTimeout(debouncedHandleCheckout, 300);
    });
  }

});



